import React from 'react';
import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

interface CustomNoRowsProps {
	title: string;
	body: string;
}

const CustomNoRowsOverlay = (props: CustomNoRowsProps) => {
	const { title, body } = props;
	const classes = useStyles();

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
			flex="1 0 100%"
			paddingTop="56px"
			paddingX={2}
			className={classes.container}
		>
			<Box mt={2}>
				<Typography variant="h5" className={classes.title}>
					{title}
				</Typography>
			</Box>
			<Box mt={2}>
				<Typography variant="body2" className={classes.body}>
					{body}
				</Typography>
			</Box>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			textAlign: 'center',
		},
		title: {
			[theme.breakpoints.down('sm')]: {
				fontSize: '1.5rem',
			},
		},
		body: {
			[theme.breakpoints.down('sm')]: {
				fontSize: '1.3rem',
			},
		},
	}),
);

export default CustomNoRowsOverlay;
